
import spritePath from "../icomoon/symbol-defs.svg"

export default {
  name: "SvgIcomoon",
  props: {
    href: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      rerenderKey: 0,
    }
  },
  computed: {
    iconHref () {
      return `${spritePath}#${this.href}`
    },
  },
  watch: {
    href: function () {
      this.rerenderKey++
    },
    size: function () {
      this.rerenderKey++
    },
  },
  created () {
    this.rerenderKey++
  },
  mounted () {
    this.rerenderKey++
  },
}
